import { useQueries, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { Page } from "v2/components";
import { IDetails, IResponse } from "./TemplateMovementsCheck.types";
import { TemplateMovementsCheckView } from "./TemplateMovementsCheck.View";
import { Tables } from "../Movimentacao/Tables";
import { getContractDisplayName } from "v2/utils/getContractDisplayName";


export function TemplateMovementsCheck() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string; templateId: string; };

  const [details, movements] = useQueries({
    queries: [
      {
        queryKey: ["pageDetail", workspaceId],
        queryFn: () => api.get<{ data: IDetails }>(`/v2/workspaces/${workspaceId}/get-details`),
        select: (data: any) => data?.data?.data as IDetails,
      },
      {
        queryKey: ["movements-check", workspaceId, templateId],
        queryFn: () => api.get<{ data: IResponse }>(`/v2/workspaces/${workspaceId}/templates/${templateId}/movements-check`),
        select: (data: any) => data?.data?.data as IResponse,
        // refetchInterval: 5000,
      },
    ],
  });

  const isLoading = (!details.isFetched && details.isFetching) || (!movements.isFetched && movements.isFetching);
  const isError = (!details.isFetched && details.isError) || (!movements.isFetched && movements.isError);

  const detailsData = details.data as IDetails | undefined;
  const movementsData = movements.data as IResponse | undefined;

  return (
    <>
      {isLoading && <div>Loading...</div>}
      {isError && <div>Error...</div>}
      {detailsData && movementsData && (
        <Page title={getContractDisplayName(detailsData)} backRoute={`/v2/workspaces/${detailsData.id}`}>
          <Page.Tab name="Atividades">
            <TemplateMovementsCheckView data={movementsData} contractType={movementsData.contractType} />
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
          <Page.Tab name="Tabelas">
            <Tables />
          </Page.Tab>
        </Page>
      )}
    </>
  );
}
